export const dark = {
  name: 'Dark',
  color: [1, 0.4, 0, 1],
  bg: [0.211, 0.2, 0.207, 1],
  grid1: [1, 1, 1, 0.5],
  grid2: [0, 1, 1, 0.5],
}
